import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import RecipientSearch from './RecipientSearch';
import username from 'flarum/common/helpers/username';
import Stream from 'flarum/common/utils/Stream';
import withAttr from 'flarum/common/utils/withAttr';
import app from 'flarum/forum/app';

export default class StartConversationModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    app.cache.conversationsRecipient = null;
    if (!!this.attrs.conversationsRecipient)
      app.cache.conversationsRecipient = this.attrs.conversationsRecipient;

    this.conversations = this.attrs.conversations;
    if (!this.conversations) this.conversations = [];

    this.already = false;

    this.messageContent = Stream('');
  }

  title() {
    return app.translator.trans('kyrne-whisper.forum.modal.title');
  }

  className() {
    return 'StartConversationModal Modal--medium';
  }

  content() {
    return [
      <div className="Modal-body" onclick={(e) => e.stopImmediatePropagation()}>
        {this.already ? (
          [
            <h2>{app.translator.trans('kyrne-whisper.forum.modal.already', { username: username(this.recpient) })}</h2>,
            <h2>{app.translator.trans('kyrne-whisper.forum.modal.copied', { username: username(this.recpient) })}</h2>,
          ]
        ) : (
          <div>
            <div class="helpText">
              {app.cache.conversationsRecipient !== null
                ? app.translator.trans('kyrne-whisper.forum.modal.help_start', { username: username(app.cache.conversationsRecipient) })
                : app.translator.trans('kyrne-whisper.forum.modal.help')}
            </div>
            <div className="AddRecipientModal-form">
              <RecipientSearch state={app.search} />
              {app.cache.conversationsRecipient !== null ? (
                <div className="AddRecipientModal-form-submit">
                  <textarea
                    value={this.messageContent()}
                    oninput={withAttr('value', this.messageContent)}
                    placeholder={app.translator.trans('kyrne-whisper.forum.chat.text_placeholder')}
                    rows="3"
                  />
                  {Button.component(
                    {
                      type: 'submit',
                      className: 'Button Button--primary',
                      disabled: !this.messageContent(),
                    },
                    app.translator.trans('kyrne-whisper.forum.modal.submit')
                  )}
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        )}
      </div>,
    ];
  }

  onsubmit(e) {
    e.preventDefault();

    const recipient = app.cache.conversationsRecipient;
    this.recpient = recipient;
    app.cache.conversationsRecipient = null;

    this.startConversation(recipient);
  }

  startConversation(recipient)
  {
    app.store
      .createRecord('conversations')
      .save({
        messageContents: this.messageContent(),
        recipient: recipient.id(),
      })
      .then((conversation) => {
        if (!conversation.notNew()) {
          this.conversations.push(conversation);
          let preconv = app.session.user.conversations();
          if (!preconv) preconv = [];
          preconv.push(conversation);
          app.session.user.conversations = Stream(preconv);

          if (!app.cache.conversations)
            app.cache.conversations = [];

          app.cache.conversations.push(conversation);

          app.eventEmitter.emit("Whisper:onAddNewMessage", conversation);

          m.redraw();

          app.modal.close();
        }
        else {
          app.store
            .createRecord('messages')
            .save({
              messageContents: this.messageContent(),
              conversationId: conversation.id(),
            }).then((message) => {

            if (!app.cache.messages[conversation.id()])
              app.cache.messages[conversation.id()] = [];

            app.eventEmitter.emit("Whisper:onAddNewMessage", conversation);
            app.cache.messages[conversation.id()].push(message);

            m.redraw();

            $('.chat-history').animate({ scrollTop: $('.chat-history').prop('scrollHeight') }, 500);
            app.request({
              method: 'POST',
              url: app.forum.attribute('apiUrl') + '/whisper/messages/read',
              body: {
                conversationId: conversation.id(),
                messageId: message.id(),
              },
            });

            app.modal.close();
          });
        }
      });
  }
}
